import { DropdownOption } from "@interfaces/components/dropdown.interface";
import { Dropdown } from "react-bootstrap";

interface Props {
  selected: string;
  options: DropdownOption[];
  onChange: (value: string) => void;
}

const CustomDropdown = ({ selected, options, onChange }: Props) => {
  const label = options.find(({ value }) => value === selected)?.label;
  return (
    <Dropdown
      className="btn-group ms-auto ms-lg-5"
      onSelect={(e) => {
        if (e) onChange(e);
      }}
    >
      <Dropdown.Toggle variant="white" id="dropdown-basic">
        {label ?? "Default Sorting"}
      </Dropdown.Toggle>
      <Dropdown.Menu className="dropdown-menu">
        {options.map(({ value, label }) => (
          <Dropdown.Item
            key={value}
            eventKey={value}
            className="dropdown-option"
          >
            {label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CustomDropdown;
